module.exports = __webpack_public_path__ + "static/play-store-57d1795f55381c6ca4461ec9338a6ca7.svg";